import React, { useState, useEffect } from 'react';
import {
    Grid,
    Container,
    FormGroup,
    FormControlLabel,
    Switch,
    IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { DataGrid } from '@mui/x-data-grid';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import CustomDialogBox from '../../components/custom-dialog-box';
import useDialogBoxHook from '../../hooks/dialog-box-hook';
import useVideoMgtHook from '../../hooks/video-mgt-hook';

export default function VideoList() {

    const columns = [
        { field: 'index', headerName: 'ลำดับ', maxWidth: 50, flex: 1 },
        { field: 'video_name', headerName: 'ชื่อ Video', minWidth: 150, flex: 1 },
        { field: 'video_body', headerName: 'เนื้อหา Video', minWidth: 150, flex: 1 },
        {
            field: "active",
            headerName: "Activated",
            sortable: false,
            maxWidth: 100,
            flex: 1,
            disableClickEventBubbling: true,
            renderCell: (cellValues) => {
                return <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                size="small"
                                checked={cellValues.row.active}
                                onClick={(event) => {
                                    handleStatusSwitch(event, cellValues);
                                }}
                            />
                        }
                        label=""
                    />
                </FormGroup>
            }
        },
        {
            field: "edit",
            headerName: "Edit",
            sortable: false,
            maxWidth: 100,
            flex: 1,
            disableClickEventBubbling: true,
            renderCell: (cellValues) => {
                return <IconButton
                    color="secondary"
                    aria-label="add an alarm"
                    onClick={(event) => {
                        handleEditClick(event, cellValues);
                    }} >
                    <EditIcon />
                </IconButton>
            }
        },
        {
            field: "delete",
            headerName: "Delete",
            sortable: false,
            maxWidth: 100,
            flex: 1,
            disableClickEventBubbling: true,
            renderCell: (cellValues) => {
                return <IconButton
                    color="secondary"
                    aria-label="add an alarm"
                    onClick={(event) => {
                        handleDeleteClick(event, cellValues);
                    }} >
                    <DeleteIcon />
                </IconButton>
            }
        }
    ];

    const {video_list, fetchVideo, actionChangeStatus, actionDelete} = useVideoMgtHook()

    const [selected_id, setSelectedId] = useState(0)
    const [selected_status, setSelectedStatus] = useState(0)
    
    const {
        is_dialog_box_open,
        dialog_box_header,
        dialog_box_body,
        dialog_box_action,
        setDialogBoxOption
    } = useDialogBoxHook()

    const handleAddClick = (event) => {
        event.preventDefault();
        window.location.href = "/admin/video/add"
    }

    const handleEditClick = (event, cellValues) => {
        event.preventDefault();
        window.location.href = "/admin/video/edit/"+cellValues.row.id
    }

    const handleDeleteClick = (event, cellValues) => {
        event.preventDefault();
        let video_id = cellValues.row.id
        let video_name = cellValues.row.video_name
        setSelectedId(video_id)
        setDialogBoxOption(
            true,
            "ลบ Video",
            "คุณต้องการลบช้อมูล Video " + video_name + " หรือไม่",
            "delete"
        )
    }

    const handleStatusSwitch = (event, cellValues) => {
        event.preventDefault();
        let video_id = cellValues.row.id
        let video_name = cellValues.row.video_name
        setSelectedId(video_id)
        setSelectedStatus(cellValues.row.active)
        setDialogBoxOption(
            true,
            "เปลี่ยนสถานะ Video",
            "คุณต้องการเปลี่ยนสถานะ Video " + video_name + " หรือไม่",
            "change_status"
        )
    }

    const handleDialogClose = (event) => {
        setDialogBoxOption(
            false,
            "",
            "",
            ""
        )
        setSelectedId(0)
    }

    const handleSubmitButton = async () => {
        let result
        if (dialog_box_action === 'change_status') {
            result = await actionChangeStatus(selected_id, selected_status)
        } else if (dialog_box_action === 'delete') {
            result = await actionDelete(selected_id)
        }
        alert(result.msg)
        if (result.result) {
            fetchVideo()
            handleDialogClose()
        }
    }

    return (
        <>
            <AdminMenu />
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"Video Management"}
                    button_title={"Add Video"}
                    handleBtnClick={handleAddClick}
                    is_main_page={true}
                />
                <Grid container>
                    <Grid item xs={12} >
                        <div style={{ height: 600, width: '100%', marginTop: '2rem' }}>
                            <DataGrid
                                style={{ backgroundColor: "#FFFFFF" }}
                                rows={video_list}
                                columns={columns}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Container>
            <CustomDialogBox
                open={is_dialog_box_open}
                handleCancleButton={handleDialogClose}
                header={dialog_box_header}
                body={dialog_box_body}
                handleSubmitButton={handleSubmitButton}
            />
        </>
    )
}